import React, { useEffect } from 'react';
import './Lookbooks.css';
import Header from '../../../components/common/Header/header';
import Lookbook from '../../../components/ui/Lookbook/Lookbook';
import ErrorDisplay from '../../../components/common/Error/Error';
import { Link } from 'react-router-dom';
import { useLookbook } from '../../../hooks/useLookbook';

function Lookbooks() {
  // Get lookbooks data, loading state, and fetch function from hook
  const { lookbooks, loading, error, fetchLookbooks } = useLookbook();

  // Fetch lookbooks on mount. Duplicate calls are deduplicated in hook/service layer.
  useEffect(() => {
    fetchLookbooks();
  }, [fetchLookbooks]);

  // Handle retry for rate limit errors
  const handleRetry = () => {
    fetchLookbooks();
  };

  // Check if error is a rate limit error
  const isRateLimitError = error && (error.includes('429') || error.includes('rate limit') || error.includes('too many requests'));

  return (
    <div className="lookbooks">
      {/* Header with navigation and branding */}
      <div className="lookbooks-header">
        <Header />
      </div>

      {/* Main content */}
      <div className="lookbooks-content">
        {/* Page hero section with title and description */}
        <div className="lookbooks-hero">
          <h1>Lookbooks</h1>
          <p>
            Découvrez nos collections à travers des shootings professionnels.
            Chaque lookbook capture l'essence et le style de la collection.
          </p>
        </div>

        {/* Lookbooks list container */}
        <div className="lookbooks-list">
          {/* Loading state */}
          {loading && (
            <div className="lookbooks-loading">
              <p>Chargement des lookbooks...</p>
              <div className="spinner"></div>
            </div>
          )}

          {/* Error state - with retry for rate limits */}
          {error && !loading && (
            <div className="lookbooks-error">
              <ErrorDisplay errorData={error} />
              {isRateLimitError && (
                <button 
                  className="retry-button"
                  onClick={handleRetry}
                >
                  Réessayer
                </button>
              )}
            </div>
          )}

          {/* Empty state */}
          {!loading && !error && lookbooks.length === 0 && (
            <div className="lookbooks-empty">
              Aucun lookbook disponible pour le moment.
            </div>
          )}

          {/* Display all lookbooks */}
          {!loading && !error && lookbooks.length > 0 && (
            lookbooks.map((lookbook) => (
              <div key={lookbook.id} className="lookbook-section">
                <Lookbook lookbook={lookbook} />
              </div>
            ))
          )}
        </div>
      </div>

      {/* Footer with legal links */}
      <footer>
        <Link to="/legal-mention">Mentions légales</Link>
        
      </footer>
    </div>
  );
}

export default Lookbooks;
